import keycloak, {getValidToken} from "../authentication/Keycloak.js";
import {consoleLog} from '../utilities/Utilities.js';
const file='Api.js';

export async function authorization(){
    let url='/api/authorization';
    try{
        const fetchResponse=await fetch(url,{
            method:"POST",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            },
            body:JSON.stringify({_lang:keycloak?.idTokenParsed?.locale||'en'}),
        });
        const response=await fetchResponse.json();
        return JSON.stringify(response);
    } 
    catch(e){
        consoleLog({file:file,context:'authorization',arg_name:'e',arg_value:e});
    }
}

export async function getLogTree(user=null){
    let responseUI={};
    let url='/api/logs/tree';
    if(user) url+='?user='+encodeURIComponent(user);
    try{
        const fetchResponse=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            }
        });
        const response=await fetchResponse.json();
        if(response===undefined||response===null){
            consoleLog({file:file,context:'getLogTree',arg_name:'Error',arg_value:"Error - response is 'undefined'/'null'"});
        }
        else{
            responseUI=JSON.parse(JSON.stringify(response));
        }
    }
    catch(e){
        consoleLog({file:file,context:'getLogTree',arg_name:'e',arg_value:e});
        responseUI={error:"Error - getLogTree: "+e.toString()};
    }
    finally{
        return responseUI
    }
}

export async function searchLogs(query,user=null,fromDate=null,toDate=null){
    let responseUI={};
    let url='/api/logs/search?q='+encodeURIComponent(query);
    if(user) url+='&user='+encodeURIComponent(user);
    if(fromDate) url+='&from_date='+encodeURIComponent(fromDate);
    if(toDate) url+='&to_date='+encodeURIComponent(toDate);
    try{
        const fetchResponse=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            }
        });
        const response=await fetchResponse.json();
        if(response===undefined||response===null){
            consoleLog({file:file,context:'searchLogs',arg_name:'Error',arg_value:"Error - response is 'undefined'/'null'"});
        }
        else{
            responseUI=JSON.parse(JSON.stringify(response));
        }
    }
    catch(e){
        consoleLog({file:file,context:'searchLogs',arg_name:'e',arg_value:e});
        responseUI={error:"Error - searchLogs: "+e.toString()};
    }
    finally{
        return responseUI
    }
}

export async function getLogContent(body){
    let responseUI={};
    let url='/api/logs/content';
    if(body.params!==undefined&&body.params.length>0){
        const searchParams=new URLSearchParams();
        body.params.forEach((param)=>{
            const eqIndex=param.indexOf('=');
            if(eqIndex===-1){
                searchParams.append(param,'');
            }
            else{
                searchParams.append(param.substring(0,eqIndex),param.substring(eqIndex+1));
            }
        });
        url+='?'+searchParams.toString();
    }
    try{
        const fetchResponse=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            }
        });
        const response=await fetchResponse.text();
        if(response===undefined||response===null){
            consoleLog({file:file,context:'getLogContent',arg_name:'Error',arg_value:"Error - response is 'undefined'/'null'"});
        }
        else{
            responseUI={log:response};
        }
    }
    catch(e){
        consoleLog({file:file,context:'getLogContent',arg_name:'e',arg_value:e});
        responseUI={error:"Error - getLogContent: "+e.toString()};
    }
    finally{
        return responseUI
    }
}

export async function getServerVariables(){
    let responseUI={};
    let url='/api/get-server-variables';
    const lang=keycloak?.idTokenParsed?.locale||'en';
    const searchParams=new URLSearchParams();
    searchParams.append('_lang',lang);
    url+='?'+searchParams.toString();
    try{
        const fetchResponse=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            }
        });
        const response=await fetchResponse.json();
        if(response===undefined||response===null){
            consoleLog({file:file,context:'getServerVariables',arg_name:'Error',arg_value:"Error - response is 'undefined'/'null'"});
        }
        else{
            responseUI=JSON.parse(JSON.stringify(response));
        }
    }
    catch(e){
        consoleLog({file:file,context:'getServerVariables',arg_name:'e',arg_value:e});
        responseUI={error:"Error - getServerVariables: "+e.toString()};
    }
    finally{
        return responseUI
    }
}

const ALLOWED_REFRESH_APIS=new Set([
    'refresh-list-of-values',
    'refresh-locales',
    'refresh-users-info',
    'refresh-app-roles',
    'refresh-modules-config',
    'refresh-app-config',
]);

export async function refreshServerVariable(api){
    if(!ALLOWED_REFRESH_APIS.has(api)){
        return {error:'Invalid API endpoint: '+api};
    }
    let responseUI={};
    let url='/api/'+api;
    
    try{
        const fetchResponse=await fetch(url,{
            method:"POST",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            }
        });
        const response=await fetchResponse.json();
        if(response===undefined||response===null){
            consoleLog({file:file,context:'refreshServerVariable',arg_name:'Error',arg_value:"Error - response is 'undefined'/'null'"});
        }
        else{
            responseUI=JSON.parse(JSON.stringify(response));
        }
    }
    catch(e){
        consoleLog({file:file,context:'refreshServerVariable',arg_name:'e',arg_value:e});
        responseUI={error:"Error - getServerVariables: "+e.toString()};
    }
    finally{
        return responseUI
    }
}

export async function exportAppConfig(){
    let responseUI={};
    const url='/api/export-app-config';
    try{
        const fetchResponse=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization:`Bearer ${await getValidToken()}`,
            }
        });
        const response=await fetchResponse.json();
        if(response===undefined||response===null){
            responseUI={error:"Empty response from export-app-config"};
        }
        else if(fetchResponse.ok){
            responseUI=response;
        }
        else{
            responseUI={error:response?.error||"Export failed"};
        }
    }
    catch(e){
        consoleLog({file:file,context:'exportAppConfig',arg_name:'e',arg_value:e});
        responseUI={error:"Error - exportAppConfig: "+e.toString()};
    }
    finally{
        return responseUI;
    }
}

export async function exportAppMenuConfig(){
    let responseUI={};
    const url='/api/export-app-menu-config';
    try{
        const fetchResponse=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization:`Bearer ${await getValidToken()}`,
            }
        });
        const response=await fetchResponse.json();
        if(response===undefined||response===null){
            responseUI={error:"Empty response from export-app-menu-config"};
        }
        else if(fetchResponse.ok){
            responseUI=response;
        }
        else{
            responseUI={error:response?.error||"Export failed"};
        }
    }
    catch(e){
        consoleLog({file:file,context:'exportAppMenuConfig',arg_name:'e',arg_value:e});
        responseUI={error:"Error - exportAppMenuConfig: "+e.toString()};
    }
    finally{
        return responseUI;
    }
}

export const logAction=async(logData)=>{
    let url='/api/log_action';
    try{
        await fetch(url,{
            method:"POST",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            },
            body:JSON.stringify(logData),
        });
    }
    catch (error) {
      consoleLog({file:file,context:'logAction',arg_name:'error',arg_value:error});
    }
};

export async function getUserNotifications(){
    let responseUI={};
    let url='/api/notifications';
    try{
        const fetchResponse=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            }
        });
        const response=await fetchResponse.json();
        if(response===undefined||response===null){
            consoleLog({file:file,context:'getUserNotifications',arg_name:'Error',arg_value:"Error - response is 'undefined'/'null'"});
        }
        else{
            responseUI=JSON.parse(JSON.stringify(response));
        }
    }
    catch(e){
        consoleLog({file:file,context:'getUserNotifications',arg_name:'e',arg_value:e});
        responseUI={error:"Error - getUserNotifications: "+e.toString()};
    }
    finally{
        return responseUI
    }
}

export async function getCacheKeys(){
    let responseUI={};
    let url='/api/cache/keys';
    try{
        const fetchResponse=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            }
        });
        const response=await fetchResponse.json();
        if(response===undefined||response===null){
            consoleLog({file:file,context:'getCacheKeys',arg_name:'Error',arg_value:"Error - response is 'undefined'/'null'"});
        }
        else{
            responseUI=JSON.parse(JSON.stringify(response));
        }
    }
    catch(e){
        consoleLog({file:file,context:'getCacheKeys',arg_name:'e',arg_value:e});
        responseUI={error:"Error - getCacheKeys: "+e.toString()};
    }
    finally{
        return responseUI
    }
}

export async function getCacheValue(key){
    let responseUI={};
    let url='/api/cache/value?key='+encodeURIComponent(key);
    try{
        const fetchResponse=await fetch(url,{
            method:"GET",
            headers:{
                "Accept":"application/json",
                "Content-Type":"application/json",
                Authorization: `Bearer ${await getValidToken()}`,
            }
        });
        const response=await fetchResponse.json();
        if(response===undefined||response===null){
            consoleLog({file:file,context:'getCacheValue',arg_name:'Error',arg_value:"Error - response is 'undefined'/'null'"});
        }
        else{
            responseUI=JSON.parse(JSON.stringify(response));
        }
    }
    catch(e){
        consoleLog({file:file,context:'getCacheValue',arg_name:'e',arg_value:e});
        responseUI={error:"Error - getCacheValue: "+e.toString()};
    }
    finally{
        return responseUI
    }
}